import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GiRotaryPhone } from "react-icons/gi";
import { MdEmail, MdMenu, MdClose, MdKeyboardArrowDown } from "react-icons/md";
import "../Header/Header.css";

const destinations = [
  { country: "South America", link: "/destination/south-america", flag: "/southamerica.jpg" },
  { country: "New Zealand", link: "/destination/new-zealand", flag: "/newzealand.jpg" },
  { country: "South Africa", link: "/destination/south-africa", flag: "/southafrica.jpg" },
  { country: "Far East", link: "/destination/far-east", flag: "/fareast.jpg" },
  { country: "Australia", link: "/destination/australia", flag: "/aus1.jpg" },
  { country: "Canada", link: "/destination/canada", flag: "/canada.jpg" },
  { country: "Indian Ocean", link: "/destination/indian-ocean", flag: "/indianocean.jpg" },
  { country: "Middle East", link: "/destination/middle-east", flag: "/middleeast.jpg" },
  { country: "USA", link: "/destination/usa", flag: "/usa.jpg" },
  { country: "Caribbean", link: "/destination/caribbean", flag: "/carribean.jpg" },
];

const logos = [
  { src: "/logon1.jpg", link: "/airlines/etihad" },
  { src: "/logon16.jpg", link: "/airlines/swiss" },
  { src: "/logon17.jpg", link: "/airlines/delta" },
  { src: "/logon10.jpg", link: "/airlines/singapore" },
  { src: "/logon2.jpg", link: "/airlines/virginatlantic" },
  { src: "/logon5.jpg", link: "/airlines/british" },
  { src: "/logon13.jpg", link: "/airlines/air-newzealand" },
  { src: "/logon18.jpg", link: "/airlines/klm" },
  { src: "/logon15.jpg", link: "/airlines/garuda-indonesia" },
  { src: "/logon11.jpg", link: "/airlines/emirates" },
  { src: "/logon12.jpg", link: "/airlines/united" },
  { src: "/logon8.jpg", link: "/airlines/qatar" },
  { src: "/logon14.jpg", link: "/airlines/malaysia-airlines" },
  { src: "/logon19.jpg", link: "/airlines/eva-air" },
  { src: "/logon7.jpg", link: "/airlines/cathaypacific" },
  { src: "/logon20.jpg", link: "/airlines/ana" },
];

const calladmin = () => {
  window.location.href = "tel:02039449931";
};

const Header = () => {
  const [hoveredSection, setHoveredSection] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDestinationsOpen, setIsDestinationsOpen] = useState(false);
  const [isAirlinesOpen, setIsAirlinesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeOverlay = () => {
    setHoveredSection(null);
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:enquiries@journeyexperts.co.uk";
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDestinations = (e) => {
    e.stopPropagation(); // Prevent the click from reaching the parent link
    setIsDestinationsOpen(!isDestinationsOpen);
  };
  
  const toggleAirlines = (e) => {
    e.stopPropagation(); // Prevent the click from reaching the parent link
    setIsAirlinesOpen(!isAirlinesOpen);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="top-bar">
        <div className="logo-container">
          <img src="/protected.png" alt="Just Fly Business" className="logo1" />
        </div>
        <div className="logo-container">
          <Link to="/"></Link>
        </div>
        <div className="contact">
          <span onClick={calladmin} >
            <GiRotaryPhone className="phone-icon"/> 02039449931
          </span>
          <p className="phone" onClick={handleEmailClick}>
            <MdEmail className="phone-icon" /> enquiries@journeyexperts.co.uk
          </p>
        </div>
      </div>

      <div className="nav">
        <Link to="/">
          <img src="/logo2.png" alt="Just Fly Business" className="logo5" />
        </Link>
        <div className="navbar-links">
          <a href="/">Home</a>
          <a href="/business-flight">Business Class Flight</a>
          <div
            className="nav-item"
            onMouseEnter={() => setHoveredSection("destination")}
            onMouseLeave={closeOverlay}
          >
            <a href="/destination">Destinations</a>
            {hoveredSection === "destination" && (
              <div className="holiday-overlay" onMouseLeave={closeOverlay}>
                <section className="list-section">
                  <div className="list-grid">
                    {destinations.map((destination, index) => (
                      <div key={index} className="destination-card">
                        <Link className="ll-h" to={destination.link} onClick={closeOverlay}>
                          <img src={destination.flag} alt={`${destination.country} flag`} className="country-flag" />
                          <h3 className="country-name">{destination.country}</h3>
                        </Link>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            )}
          </div>
          {/*-
          <div
            className="nav-item"
            onMouseEnter={() => setHoveredSection("airline")}
            onMouseLeave={closeOverlay}
          >
            <a href="/airline">Airlines</a>
            {hoveredSection === "airline" && (
              <div className="holiday-overlay" onMouseLeave={closeOverlay}>
                <section className="airline-section">
                  <div className="logo-grid">
                    {logos.map((logo, index) => (
                      <div className="logo-item" key={index}>
                        <Link className="ll-h" to={logo.link} onClick={closeOverlay}>
                          <img src={logo.src} alt={`Airline logo ${index + 1}`} />
                        </Link>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            )}
          </div>
          -*/}
        </div>
        <div className="hamburger-menu" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <MdClose className="hamburger-icon" /> : <MdMenu className="hamburger-icon" />}
        </div>
      </div>

      <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
        <a href="/" onClick={closeMobileMenu}>Home</a>
        <div className="mobile-dropdown">
          <div className="dropdown-header">
            <Link to="/destination" onClick={closeMobileMenu}>Destinations</Link>
            <button className="dropdown-toggle" onClick={toggleDestinations}>
              <MdKeyboardArrowDown className={`dropdown-iconn ${isDestinationsOpen ? "open" : ""}`} />
            </button>
          </div>
          {isDestinationsOpen && (
            <div className="dropdown-content">
              {destinations.map((destination, index) => (
                <Link className="dd-l" key={index} to={destination.link} onClick={closeMobileMenu}>
                  {destination.country}
                </Link>
              ))}
            </div>
          )}
        </div>
        <a href="/business-flight" onClick={closeMobileMenu}>Business Class Flight</a>
        {/*-
        <a href="/airline" onClick={closeMobileMenu}>Airlines</a>
        -*/}
      </div>
    </header>
  );
};

export default Header;